/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import {
  FETCH_CONTENTS_DETAILS_REQUEST,
  FETCH_CONTENTS_DETAILS_SUCCESS,
  FETCH_CONTENTS_DETAILS_FAILURE,
  FETCH_DOMAIN_APPROVER_CONTENTS_REQUEST,
  FETCH_DOMAIN_APPROVER_CONTENTS_SUCCESS,
  FETCH_DOMAIN_APPROVER_CONTENTS_FAILURE,
} from "./ContentsDetailsTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchContentsDetailsRequest = () => {
  return {
    type: FETCH_CONTENTS_DETAILS_REQUEST,
  };
};

export const fetchContentsDetailsSuccess = (contentDetails) => {
  return {
    type: FETCH_CONTENTS_DETAILS_SUCCESS,
    payload: contentDetails,
  };
};

export const fetchContentsDetailsFailure = (error) => {
  return {
    type: FETCH_CONTENTS_DETAILS_FAILURE,
    payload: error,
  };
};

export const fetchContentsDetails = (status,isCountNeeded) => {
  return async function (dispatch) {
    dispatch(fetchContentsDetailsRequest());
    try {
      const data = await APIManager.getContentData(status, isCountNeeded);
      dispatch(fetchContentsDetailsSuccess(data));
    } catch (error) {
      dispatch(fetchContentsDetailsFailure(error));
      dispatch(commonError(error, FETCH_CONTENTS_DETAILS_FAILURE));
    }
  };
};

export const commonError=(error,errorType)=>{
  return({
    type:COMMON_ERROR,
    payload:{
      message:error.message,
      errorType:errorType
    }
  })
}

// Domain Approver Contents Actions
export const fetchDomainApproverContentsRequest = () => {
  return {
    type: FETCH_DOMAIN_APPROVER_CONTENTS_REQUEST,
  };
};

export const fetchDomainApproverContentsSuccess = (contents) => {
  return {
    type: FETCH_DOMAIN_APPROVER_CONTENTS_SUCCESS,
    payload: contents,
  };
};

export const fetchDomainApproverContentsFailure = (error) => {
  return {
    type: FETCH_DOMAIN_APPROVER_CONTENTS_FAILURE,
    payload: error,
  };
};

export const fetchDomainApproverContents = () => {
  return async function (dispatch) {
    dispatch(fetchDomainApproverContentsRequest());
    try {
      const data = await APIManager.getDomainApproverContent();
      dispatch(fetchDomainApproverContentsSuccess(data));
    } catch (error) {
      dispatch(fetchDomainApproverContentsFailure(error));
      dispatch(commonError(error, FETCH_DOMAIN_APPROVER_CONTENTS_FAILURE));
    }
  };
};
